export default "__VITE_ASSET__229fadf0__"